import web3 from '../../plugins/web3'
import contract from '../../plugins/ethereum_contracts'
import firebase from 'firebase'
import { SHOW_ALERT } from '../actions'

const state = {
	defaultAccount: null,
	metamaskInstalled: false,
	token: 0,
	token721: 0,
	totalEths: 0,
	error: null,
	fees: [{name: 'Buy Token', value: 0.009},
		{name: 'Buy Token', value: 0.009},
		{name: 'Sell Estate', value: 0.009},
		{name: 'Buy Token', value: 0.009},
		{name: 'Buy Token', value: 0.009},
		{name: 'Sell Estate', value: 0.009},
		{name: 'Sell Estate', value: 0.009},
		{name: 'Buy Token', value: 0.009},
		{name: 'Buy Token', value: 0.009},
		{name: 'Sell Estate', value: 0.009}
	],
	buyEstatesQueue: [],
	buyRE20Queue: [],
	isLoading: false,
}

const actions = {
	loadAccount: ({commit, dispatch}, next) => {
		if (web3 == undefined || web3 == null) {
			commit ('setMetamask', false)
			console.log ('No metamask account: alert the user')
			return
		}
	
		web3
			.eth
			.getCoinbase ()
			.then (defaultAccount => {
				console.log ('Selected account is', defaultAccount)
				if (!defaultAccount) {
					commit ('setMetamask', false)
					console.log ('No metamask account: alert the user')
					return
				}
				commit ('setMetamask', true)
				commit ('setAccount', defaultAccount)
				
				if (next)
					dispatch (next)
			})
			.catch (error => {
				commit ('setError', error)
			})


	},

	loadWallet: ({ state, commit, dispatch }) => {
		if (web3 == undefined || web3 == null) {
			commit ('setMetamask', false)
			console.log ('No metamask account: alert the user')
			return
		}

		if (!state.defaultAccount) {
			dispatch ('loadAccount', 'loadWallet')
			return
		}
		const { defaultAccount } = state

		// Load ether balance
		web3
			.eth
			.getBalance (defaultAccount)
			.then (balance => {
				commit ('setEtherBalance', web3.utils.fromWei (balance, 'ether'))
			})
			.catch (error => {
				commit ('setError', error)
			})
		
		// Load RE20 balance
		contract.RE20ICO.methods.balanceOf (defaultAccount).call ()
			.then (tokens => commit ('setTokens', tokens))
			.catch (error => {
				commit ('setError', error)
			})
		
		// Load RE721 balance
		contract.RE721.methods.balanceOf (defaultAccount).call ()
			.then (tokens => commit ('setTokens721', tokens))
			.catch (error => {
				commit ('setError', error)
			})
	},

	buyRE20: ({commit, state, dispatch}, amount) => {
		if (web3 == undefined || web3 == null) {
			commit ('setMetamask', false)
			console.log ('No metamask account: alert the user')
			return
		}

		// Show loader during confirmation
		commit ('showLoader', true)
		
		web3.eth.sendTransaction ({
			from: state.defaultAccount,
			to: contract.RE20ICO.options.address,
			value: web3.utils.toWei (amount, 'ether')
		}, function (error, hash) {
			if (error) {
				// Hide the loader
				commit ('showLoader', false)
				console.log (error, hash)
				commit ('setError', error.message)
				return
			}
		})

		contract.RE20ICO.once ('Transfer', {}, (error, event) => {
			// Hide the loader
			commit ('showLoader', false)
			if (error) {
				commit ('setError', error)
				return
			}
					
			/* const {
				from,
				to,
				value			
			} = event.returnValues

			console.log (`Transfered ${web3.utils.fromWei ('' + value, 'ether')} to recipient address ${to} from contract address ${from}`)
*/
			commit (SHOW_ALERT, {
				text: 'Congratulations!',
				message: 'Transfer successful!',
				dismissable: true,
				actions: []
			})

			/* firebase.database ().ref ('approved_transactions_re20').push ({
				spender: to,
				owner: from,
				value: value.toString ()
			})*/
			dispatch ('loadWallet')
		})
		/* firebase.database ().ref ('transactions_re20').push ({
			'from': state.defaultAccount, 
			'amount': amount
		})
		commit ('addBuyRE20', {
			'from': state.defaultAccount, 
			'amount': amount
		})*/
	},

	buyEstate: ({commit, state, getters}, estate) => {
		if (estate.owner == state.defaultAccount) {
			console.log ('You can\'t buy your own estate')
			return
		}

		if (parseFloat (estate.buy_cost) > parseFloat (getters.tokenRE20)) {
			console.log ('Not enough tokens to buy the estate!')
			return
		}

		// Show loader during confirmation
		commit ('showLoader', true)

		firebase.database ().ref ('transactions').push ({
			'from': state.defaultAccount, 
			'tokens': estate.buy_cost, 
			'token_id': estate['token-id'],
			'owner': estate.owner
		})
		commit ('addBuyEstate', {
			'from': state.defaultAccount, 
			'token_id': estate['token-id'],
			owner: estate.owner
		})
	},

	// Transfers an `amount` of RE20 to a `recipient`. No ethers are required for the exchange
	// Used to Sell RE20
	transferRE20: ({commit, state, dispatch}, { recipient, amount }) => {
		if (web3 == undefined || web3 == null) {
			console.log ('No metamask account: alert the user')
			return
		}
	
		contract.RE20ICO.methods.transfer (recipient, amount)
			.send ({
				from: state.defaultAccount,
			})
			.catch (error => {
				commit ('setError', error)
			})

		contract.RE20ICO.once ('Transfer', {}, (error, event) => {
			if (error) {
				commit ('setError', error)
				return
			}
					
			const {
				from,
				to,
				value			
			} = event.returnValues

			console.log (`Transfered ${value} to recipient ${to} from ${from}`)

			// Hide the loader because the transaction is now complete
			commit ('showLoader', false)

			commit (SHOW_ALERT, {
				text: 'Congratulations!',
				message: 'Transfer successful!',
				dismissable: true,
				actions: []
			})

			firebase.database ().ref ('approved_transactions_re20').push ({
				spender: to,
				owner: from,
				value: value.toString ()
			})
			dispatch ('loadWallet')
		})
	},

	approveAddress: ({commit, state, dispatch}, { address, token, tokens }) => {
		if (web3 == undefined || web3 == null) {
			console.log ('No metamask account: alert the user')
			return
		}

		contract.RE721.methods.approve (address, token)
			.send ({
				from: state.defaultAccount,
			})
			.catch (error => {
				commit ('showLoader', false)
				commit (SHOW_ALERT, {
					text: 'Error!',
					message: 'An error occurred approving estate transfer.',
					dismissable: true,
					actions: []
				})

				commit ('setError', error)
			})
		
		contract.RE721.once ('Approval', {}, (error, event) => { 
			if (error) {
				commit ('showLoader', false)
				commit (SHOW_ALERT, {
					text: 'Error!',
					message: 'An error occurred approving estate transfer.',
					dismissable: true,
					actions: []
				})
				commit ('setError', error)
				return
			}
			const {
				_approved,
				_owner,
				_tokenId
			} = event.returnValues
			
			console.log ('Approved token and user: ', _tokenId, _approved)
			
			commit ('showLoader', false)
			commit (SHOW_ALERT, {
				text: 'Congratulations!',
				message: 'Estate sold successfully!',
				dismissable: true,
				actions: []
			})
			
			dispatch ('loadWallet')
 
			firebase.database ().ref ('approved_transactions').push ({
				'from': _approved,
				'token_id': _tokenId.toString (),
				'owner': _owner,
				'tokens': tokens
			})
		})
	},

	transferEstateOwnership: ({commit, state, dispatch}, estate) => {
		if (web3 == undefined || web3 == null) {
			console.log ('No metamask account: alert the user')
			return
		}

		console.log (`Trasferring estate [Token ${estate.token_id}] from ${estate.owner} to ${estate.from}. Costs ${estate.tokens} RE20`)

		contract.RE20ICO.methods.transfer (
			estate.owner, 
			'' + web3.utils.toWei ('' + estate.tokens, 'ether'))
			.send ({
				from: state.defaultAccount,
				to: estate.owner,
			}, (error) => {
				if (!error)
					return
				commit ('showLoader', false)
				commit ('setError', error)
				commit (SHOW_ALERT, {
					text: 'Error!',
					message: 'An error occurred trasfering estate ownership.',
					dismissable: true,
					actions: []
				})
			})

		contract.RE20ICO.once ('Transfer', {}, (error, event) => {
			if (error) {
				commit ('setError', error)
				return
			}

			console.log ('Transazione di denaro approvata, trasferimento dell ownership del contratto RE720 in corso.')
			console.log ('Transaction hash:', event.transactionHash)
			dispatch ('loadWallet')

			contract.RE721.methods.safeTransferFrom (estate.owner, estate.from, estate.token_id).send ({
				from: state.defaultAccount,
			})
	
			contract.RE721.once ('Transfer', {}, (error, event) => {
				if (error) {
					commit ('setError', error)
					return
				}
				
				console.log ('Transfer successfull!', event)

				firebase.database ().ref ('estates').orderByChild ('token-id').equalTo (estate.token_id). once ('value', function (value) {
					value.forEach (function (child) {
						firebase.database ().ref ('estates/' + child.key).update ({ for_sale: false, owner: state.defaultAccount }).then ( () => {
							console.log ('owner successfully updated')
						
							// Hide the loader because the transaction is now complete
							commit ('showLoader', false)
							dispatch ('loadWallet')
							dispatch ('LOAD_ESTATES')
						
							commit (SHOW_ALERT, {
								text: 'Congratulations!',
								message: 'Estate purchased successfully!',
								dismissable: true,
								actions: []
							})

						}).catch ( (error) => {
							console.log (error)
						})
					}) 
				})
			})
		})
	}
}

const mutations = {
	incrementToken (state,payload) {
		state.token = parseFloat (state.token + payload.value)
		state.fees.push (payload.fee)
	},
	decrementToken (state,payload) {
		state.token = parseFloat (state.token - payload)
	},
	setEtherBalance (state, payload) {
		state.totalEths = payload
	},
	setError (state, error) {
		state.error = error
		
		console.error (error)
	},
	setAccount (state, account) {
		state.defaultAccount = account
	},
	setTokens (state, tokens) {
		state.token = tokens
	},
	setTokens721 (state, tokens) {
		state.token721 = tokens
	},
	addBuyEstate (state, estate) {
		state.buyEstatesQueue = [
			...state.buyEstatesQueue,
			estate
		]
	},
	addBuyRE20 (state, re20Transaction) {
		state.buyRE20Queue = [
			...state.buyRE20Queue,
			re20Transaction
		]
	},
	setMetamask (state, value) {
		state.metamaskInstalled = value
	},
	showLoader (state, value) {
		state.isLoading = value
	}
}

const getters = {
	tokenRE20: state => web3 != null ? web3.utils.fromWei ('' + state.token, 'ether') : 0
}

export default {
	state,
	actions,
	mutations,
	getters
}